/**
 * Header accent bar that doubles as a sync progress indicator.
 * Solid green when idle, animated sliding highlight when syncing.
 */
export default function SyncProgressBar({ isSyncing = false }) {
    return (
        <div className="absolute bottom-0 left-0 right-0 h-[2px] overflow-hidden">
            {/* Base solid green bar */}
            <div className="absolute inset-0 bg-brand-primary" />

            {/* Animated highlight overlay — only visible when syncing */}
            {isSyncing && (
                <div
                    className="absolute inset-0"
                    style={{
                        background: 'linear-gradient(90deg, transparent 0%, rgba(255,255,255,0.7) 50%, transparent 100%)',
                        width: '50%',
                        animation: 'sync-progress 1.2s ease-in-out infinite',
                    }}
                />
            )}
        </div>
    );
}
